import { UserAuthService, AuthenticationError } from '../services/auth/auth_user.service'
import { TokenService } from '../services/auth/token.service'
import { router } from '@/modules/router'

// TODO not use still but it has to at some short point
// https://medium.com/@zitko/structuring-a-vue-project-authentication-87032e5bfe16

const state = {
  show: false,
  messageCode: 0,
  message: ''
}

const getters = {
  isShow: (state) => {
    return state.show
  },
  message: (state) => {
    return state.message
  }
}

const mutations = {

  changeShow (state, status:boolean) {
    state.show = status
  },

  activateMessage (state, { code, message }) {
    state.show = true
    state.messageCode = code
    state.message = message
  }
}

const actions = {
  activate ({ commit }, { code, message }) {
    commit('activateMessage', { code, message })
  }
}

export const SnackbarStore = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
